import { AuthService } from './../../../core/services/auth/auth.service';
import { ClientSearchParams } from 'src/app/shared/models/clients/clientSearchParams';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ColumnMode, SelectionType } from '@swimlane/ngx-datatable';
import { NgxSpinnerService } from 'ngx-spinner';
import { ClientsApiService } from 'src/app/core/services/api/clients-api.service';
import { Client, ClientLite } from 'src/app/shared/models/clients/client';
import { SearchParams } from 'src/app/shared/models/searchParams';
import { Router, Route, ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PrintService } from 'src/app/core/services/print.service';

@Component({
  selector: 'app-clients',
  templateUrl: './clients.component.html',
  styleUrls: ['./clients.component.scss']
})
export class ClientsComponent implements OnInit {
  public clients: ClientLite[] = [];
  public count = 0;
  public params: ClientSearchParams = new ClientSearchParams();
  columns = [{ prop: 'id' }, { prop: 'fullName' }, { prop: 'location' }, { prop: 'statusStr', name: 'Status' }, { prop: 'createdDate' }];
  columnMode: ColumnMode;
  selected = [];
  SelectionType = SelectionType;

  @ViewChild('myTable') table: any;
  constructor(private spinner: NgxSpinnerService,
    private apiService: ClientsApiService,
    private router: Router,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private printService: PrintService,
    private authService: AuthService
  ) {
  }


  ngOnInit(): void {
    this.loadClients();
  }

  loadClients() {
    this.spinner.show();
    if (this.authService.user.isAdmin) {
      this.params.isApproved = null;
    }
    this.apiService.getClientLite(this.params).subscribe(
      c => {
        this.clients = c.results;
        this.count = c.count;
        this.selected = [c[2]];
        this.spinner.hide();
      }
    )
  }

  onDetailToggle(event) {
    console.log('Detail Toggled', event);
  }

  onPage(page) {
    this.params.page = page.offset + 1;
    this.loadClients();
  }

  onSort(sort) {
    debugger;
  }

  onSearch(e: KeyboardEvent) {
    if (e.keyCode === 13) {
      this.params.page = 1;
      this.params.search = (e.target as HTMLInputElement).value;
      this.loadClients();
    }
  }

  onSelect({ selected }) {
    this.router.navigate([`${selected[0].id}`], { relativeTo: this.route });
  }

  openModal(content) {
    this.modalService.open(content, { centered: true, size: 'xl' });
  }

  newClient() {
    this.router.navigate(['./new'], { relativeTo: this.route });
  }

  print() {
    this.printService.data = this.clients;
    this.printService.printDocument('clients');
  }
}
